var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUserIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.821,
    height: 28.821,
    viewBox: "0 0 28.821 28.821",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M26.535,18.3a13.5,13.5,0,0,0-3.443-2.155,1.126,1.126,0,1,0-.914,2.058,11.258,11.258,0,0,1,2.871,1.789,4.489,4.489,0,0,1,1.521,3.374v2.083a1.127,1.127,0,0,1-1.126,1.126H3.378a1.127,1.127,0,0,1-1.126-1.126V23.361a4.489,4.489,0,0,1,1.521-3.374c1.137-1,4.452-3.325,10.638-3.325a8.341,8.341,0,1,0-5.075-1.729A15.652,15.652,0,0,0,2.286,18.3,6.741,6.741,0,0,0,0,23.361v2.083a3.381,3.381,0,0,0,3.378,3.378H25.444a3.381,3.381,0,0,0,3.378-3.378V23.361A6.741,6.741,0,0,0,26.535,18.3ZM8.331,8.331a6.08,6.08,0,1,1,6.08,6.08A6.086,6.086,0,0,1,8.331,8.331Z",
    fill: "#848484"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/userIcon.19e680d3.svg";
export { ForwardRef as ReactComponent };